// import { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";
// import "./AlaramLog.css";
// import { AppThemeContext } from "../../context/AppThemeContext";
// import { BaseUrl } from "../../api/AxiosApi";
// import { groupListApi } from "../../api/Api";
// import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton, Stack } from '@mui/material';
// import { AlaramLogApi } from "../../../../api/Api";

// function AlaramLog() {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(15);


//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

//         // Generate credentials dynamically using current values
//         const credentials = {
//             LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//             LOC_CODE: sessionStorage.getItem("LCODE"),
//             PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//             WEB_KEY: "WEBXYZ321",
//             iROW: 1

//         };

//         //  console.log("Fetching data with credentialsHeader:", credentials);

//         try {
//             const res = await AlaramLogApi(credentials);
//             if (res?.CURR_ALARM && Array.isArray(res.CURR_ALARM)) {
//                 setLogData(res.CURR_ALARM);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // // Re-fetch data whenever StartDate, EndDate, or ID changes
//     useEffect(() => {
//         fetchLogData();
//     }, [sessionStorage.getItem("LoginID")]); // Add `ID` as a dependency


//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Get table headers from the first item in logData (dynamically)
//     const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//     // Export to Excel
//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, `AlaramLog`);
//         XLSX.writeFile(wb, `AlaramLog`);
//     };

//     // Export to PDF
//     const exportToPDF = () => {
//         const doc = new jsPDF();

//         // Add Logo (x, y, width, height)
//         const imgWidth = 30;  // Adjust width
//         const imgHeight = 20; // Adjust height
//         const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
//         doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

//         // Add Title or Text Below the Logo
//         const title = `AlaramLog`;
//         doc.setFontSize(12);  // Adjust font size
//         doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

//         // Adjust Y position for the table to start below the text
//         let startY = 50;  // Push table further down below text

//         doc.autoTable({
//             head: [tableHeaders],
//             body: logData.map((item) => tableHeaders.map((key) => item[key])),
//             startY: startY,  // Start table below the logo and text
//             theme: "grid",
//         });

//         doc.save(`AlaramLog`);
//     };


//     return (
//         <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                 <Modal.Title>Update User Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Grid container style={{ padding: "0", margin: "0" }}>


//                     <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

//                         <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
//                             {/* First Card */}
//                             <Stack
//                                 component={Card}
//                                 p={spacing(1)}
//                                 sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
//                             >

//                                 <div>

//                                     <div style={{
//                                         marginBottom: "5px",
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         alignItems: "center",
//                                         gap: "16px",
//                                     }}>
//                                         {/* Left-side title */}
//                                         <div style={{ marginLeft: "7px", fontSize: "14px" }}>
//                                             Daily Curtailment
//                                         </div>

//                                         {/* Right-side date pickers */}
//                                         <div style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             gap: "10px"
//                                         }}>

//                                             <button onClick={onRefreshData} className='button-style' >Show</button>
//                                             <button onClick={exportToExcel} className='export-button' >Excel</button>
//                                             <button onClick={exportToPDF} className='export-button2' >PDF</button>



//                                         </div>
//                                     </div>

//                                     <div style={{ padding: "4px", marginTop: ".4rem" }}>


//                                         <div className="table-responsive">
//                                             <table className="table table-hover table-bordered">
//                                                 <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                                                     <tr>
//                                                         {tableHeaders.map((header, index) => (
//                                                             <th key={index} className='table-heading' style={{ color: PrimaryColor }}>{header}</th>
//                                                         ))}
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {loading ? (
//                                                         <tr>
//                                                             <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
//                                                         </tr>
//                                                     ) : currentData.length > 0 ? (
//                                                         currentData.map((item, rowIndex) => (
//                                                             <tr key={rowIndex}>
//                                                                 {tableHeaders.map((key, index) => (
//                                                                     // <td key={index} className="text-center align-middle" style={tableBody}>
//                                                                     //     {item[key] || ""}
//                                                                     // </td>
//                                                                     <td key={index} className="text-center align-middle table-body">
//                                                                         {item[key] ?? ""}
//                                                                     </td>

//                                                                 ))}
//                                                             </tr>
//                                                         ))
//                                                     ) : (
//                                                         <tr>
//                                                             <td colSpan={tableHeaders.length} className="text-center">No data available</td>
//                                                         </tr>
//                                                     )}
//                                                 </tbody>
//                                             </table>
//                                         </div>

//                                         {/* Pagination */}
//                                         <div style={{ textAlign: "right", marginTop: "10px" }}>
//                                             <button
//                                                 onClick={() => handlePageChange(currentPage - 1)}
//                                                 disabled={currentPage === 1}
//                                                 className='pagination-button'
//                                                 style={{ color: PrimaryColor }}
//                                             >
//                                                 Previous
//                                             </button>
//                                             {[...Array(totalPages)].map((_, index) => (
//                                                 <button
//                                                     key={index}
//                                                     onClick={() => handlePageChange(index + 1)}
//                                                     style={{

//                                                         backgroundColor: currentPage === index + 1 ? PrimaryColor : PrimaryColor,
//                                                         color: currentPage === index + 1 ? "#fff" : "#fff",
//                                                     }}
//                                                     className='pagination-button'
//                                                 >
//                                                     {index + 1}
//                                                 </button>
//                                             ))}
//                                             <button
//                                                 onClick={() => handlePageChange(currentPage + 1)}
//                                                 disabled={currentPage === totalPages}
//                                                 className='pagination-button'
//                                                 style={{ color: PrimaryColor }}

//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </Stack>


//                         </Stack>


//                     </Grid>

//                 </Grid>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AlaramLog;


import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import "./AlaramLog.css";
import logo from '../../../../assets/img/logos/LT2logo.jpeg';
import { AppThemeContext } from "../../../../context/AppThemeContext";


import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, IconButton, Stack } from '@mui/material';
import { AlaramLogApi } from "../../../../api/Api";
import { format } from "date-fns";

function AlaramLog({ show, handleClose}) {
       const { palette, spacing, shape: { borderRadius } } = useTheme()
    const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);
     const [showModal, setShowModal] = useState(false);
        


    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        // Generate credentials dynamically using current values
        const credentials = {
            LOGIN_ID: sessionStorage.getItem("LoginID") || "",
            LOC_CODE: sessionStorage.getItem("LCODE"),
            PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
            WEB_KEY: "WEBXYZ321",
            iROW: 1

        };

        //  console.log("Fetching data with credentialsHeader:", credentials);

        try {
            const res = await AlaramLogApi(credentials);
            if (res?.CURR_ALARM && Array.isArray(res.CURR_ALARM)) {
                setLogData(res.CURR_ALARM);
            } else {
                setLogData([]);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    // // Re-fetch data whenever StartDate, EndDate, or ID changes
    useEffect(() => {
        fetchLogData();
    }, [sessionStorage.getItem("LoginID")]); // Add `ID` as a dependency


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Get table headers from the first item in logData (dynamically)
    const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

    // Export to Excel
    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, `AlarmLog`);
        XLSX.writeFile(wb, `AlarmLog`);
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Add Logo (x, y, width, height)
        const imgWidth = 30;  // Adjust width
        const imgHeight = 20; // Adjust height
        const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
        doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

        // Add Title or Text Below the Logo
        const title = `AlarmLog`;
        doc.setFontSize(12);  // Adjust font size
        doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

        // Adjust Y position for the table to start below the text
        let startY = 50;  // Push table further down below text

        doc.autoTable({
            head: [tableHeaders],
            body: logData.map((item) => tableHeaders.map((key) => item[key])),
            startY: startY,  // Start table below the logo and text
            theme: "grid",
        });

        doc.save(`AlarmLog`);
    };


    return (
        <Modal show={show} onHide={handleClose} centered  size="lg">
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Alarm Log</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Grid container style={{ padding: "0", margin: "0" }}>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                        <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                            {/* First Card */}
                            <Stack
                                component={Card}
                                p={spacing(1)}
                                sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                            >

                                <div>

                                    <div style={{
                                        marginBottom: "5px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "16px",
                                    }}>
                                        {/* Left-side title */}
                                        <div style={{ marginLeft: "7px", fontSize: "14px" }}>
                                        Alarm Log
                                        </div>

                                        {/* Right-side date pickers */}
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px"
                                        }}>

                                            {/* <button onClick={onRefreshData} className='button-style' >Show</button> */}
                                            <button onClick={exportToExcel} className='export-button' >Excel</button>
                                            <button onClick={exportToPDF} className='export-button2' >PDF</button>


                                        </div>
                                    </div>

                                    <div style={{ padding: "4px", marginTop: ".4rem" }}>


                                        <div className="table-responsive">
                                            <table className="table table-hover table-bordered">
                                                <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                                    <tr>
                                                        {tableHeaders.map((header, index) => (
                                                            <th key={index} className='table-heading' style={{ color: PrimaryColor }}>{header}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
                                                        </tr>
                                                    ) : currentData.length > 0 ? (
                                                        currentData.map((item, rowIndex) => (
                                                            <tr key={rowIndex}>
                                                                {tableHeaders.map((key, index) => (
                                                                    // <td key={index} className="text-center align-middle" style={tableBody}>
                                                                    //     {item[key] || ""}
                                                                    // </td>
                                                                    <td key={index} className="text-center align-middle table-body">
                                                                        {item[key] ?? ""}
                                                                    </td>

                                                                ))}
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={tableHeaders.length} className="text-center">No data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                className='pagination-button'
                                                style={{ color: PrimaryColor }}
                                            >
                                                Previous
                                            </button>
                                            {[...Array(totalPages)].map((_, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handlePageChange(index + 1)}
                                                    style={{

                                                        backgroundColor: currentPage === index + 1 ? PrimaryColor : PrimaryColor,
                                                        color: currentPage === index + 1 ? "#fff" : "#fff",
                                                    }}
                                                    className='pagination-button'
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                className='pagination-button'
                                                style={{ color: PrimaryColor }}

                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Stack>


                        </Stack>


                    </Grid>

                </Grid>
            </Modal.Body>
        </Modal>
    );
}

export default AlaramLog;


